import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useGetReportsTravelRule } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './ReportsTravelRuleTable.elements'

// Views
import { Table, EmptyTablePlaceholder, LoadingTablePlaceholder } from 'views/components'

import ReportsTravelRuleTableItem from '../ReportsTravelRuleTableItem'
import ReportsTravelRuleTableHeader from '../ReportsTravelRuleTableHeader'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function ReportsTravelRuleTable(props) {
  // Destructure
  const { filters, ui, actions } = props

  // Store States
  const { reportsTravelRuleFilters } = filters
  const { isPageTableUpdated } = ui
  const { setIsPageTableUpdated, setReportsTravelRuleFilters, showAlert } = actions

  // Hooks
  const { getReportsTravelRule, getReportsTravelRuleData, getReportsTravelRuleError, isGetReportsTravelRuleLoading } =
    useGetReportsTravelRule()

  // Local states
  const [reports, setReports] = useState([])
  const [pagination, setPagination] = useState()

  // Functions
  const fetchData = () => {
    getReportsTravelRule(reportsTravelRuleFilters)
  }

  useEffect(() => fetchData(), [reportsTravelRuleFilters])
  useEffect(() => {
    if (isPageTableUpdated) {
      fetchData()
      setIsPageTableUpdated(false)
    }
  }, [isPageTableUpdated])
  useEffect(() => {
    if (getReportsTravelRuleData) {
      setReports(getReportsTravelRuleData.items)
      setPagination(getReportsTravelRuleData.pagination)
    }
  }, [getReportsTravelRuleData])
  useEffect(() => {
    // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    if (getReportsTravelRuleError) showAlert({ type: 'error', message: 'An error occurred in fetching reports' })
  }, [getReportsTravelRuleError])
  return (
    <TableWrapper>
      <Table
        totalItems={pagination?.total && pagination.total}
        minWidth={900}
        tableFilters={reportsTravelRuleFilters}
        setTableFilters={setReportsTravelRuleFilters}
      >
        {/* <ReportsTravelRuleTableFilter /> */}
        <ReportsTravelRuleTableHeader />
        {reports.length > 0 && !isGetReportsTravelRuleLoading && (
          <>
            {reports.map((data) => (
              <ReportsTravelRuleTableItem key={data.id} data={data} />
            ))}
          </>
        )}
        {reports.length < 1 && (
          <div>
            {isGetReportsTravelRuleLoading ? (
              <LoadingTablePlaceholder />
            ) : (
              <EmptyTablePlaceholder setFilter={setReportsTravelRuleFilters} />
            )}
          </div>
        )}
      </Table>
    </TableWrapper>
  )
}

// Default Props
ReportsTravelRuleTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
ReportsTravelRuleTable.propTypes = {
  filters: PropTypes.shape({
    reportsTravelRuleFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setToBeUpdatedAccount: PropTypes.func,
    setAccountDirectoryFilters: PropTypes.func,
    setIsIndividualAccountDrawerOpen: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setReportsTravelRuleFilters: PropTypes.func,
    showAlert: PropTypes.func,
    toggleUpgradeModal: PropTypes.func,
    setInfoModalDetails: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsTravelRuleTable)
